<template>
    <p>
        {{ userStore.user.firstname }} {{ userStore.user.lastname }}
        <br />
        {{ userStore.user.address }}
        <br />
        {{ userStore.user.city }}, {{ userStore.user.state }} {{ userStore.user.zipcode }}
        <br />
        {{ userStore.user.ssn }}
        <br />
        <br />
        {{ creditBureau.address_name }}
        <br />
        {{ creditBureau.street_address }}
        <br />
        {{ creditBureau.city }}, {{ creditBureau.state_abbrev }} {{ creditBureau.zipcode }}
        <br />
        <br />
        Date: {{ date }}
    </p>
    <div class="page">
        <p class="letter-content">
            This letter is to inform you that I recently received a copy of my credit report that your company publishes and after reviewing it
            I found a number of items on the report that I do not recognize or believe are inaccurate.
            The accounts in question are listed below:
        </p>
        <p>
            <template v-for="(accounts, index) in selectedAccounts">
                <strong>NAME OF ACCOUNT:</strong> {{ reportStore.getAccountDetail(accounts).furnisher_name }}<br>
                <template v-if="reportStore.getAccountDetail(accounts).reference_number">
                    <strong>REFERENCE NUMBER: </strong>{{ reportStore.getAccountDetail(accounts).reference_number }}<br>
                </template>
                <template v-else>
                    <strong>ACCOUNT NUMBER: </strong>{{ reportStore.getAccountDetail(accounts).account_number }}<br>
                </template>
                <strong>PROVIDE PHYSICAL PROOF OF VERIFICATION:</strong> UNVERIFIED ACCOUNT <br><strong>Detail:</strong><br/>
                <table class="table table-success table-striped table-hover mb-0">
                    <thead class="thead-primary">
                        <tr>
                            <th></th>
                            <th>
                                TransUnion
                            </th>
                            <th>
                                Experian
                            </th>
                            <th>
                                Equifax
                            </th>
                        </tr>
                    </thead>
                    <tbody class="table-striped">
                        <tr>
                            <td>Account Number:</td>
                            <td>
                                <p class="mb-0">
                                    {{ accounts[0].account_number }}
                                </p>
                            </td>
                            <td>
                                <p class="mb-0">
                                    {{ accounts[1].account_number }}
                                </p>
                            </td>
                            <td>
                                <p class="mb-0">
                                    {{ accounts[2].account_number }}
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td>Account Status:</td>
                            <td>
                                <p class="mb-0">
                                    {{ accounts[0].account_status }}
                                </p>
                            </td>
                            <td>
                                <p class="mb-0">
                                    {{ accounts[1].account_status }}
                                </p>
                            </td>
                            <td>
                                <p class="mb-0">
                                    {{ accounts[2].account_status }}
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td>Account Type:</td>
                            <td>
                                <p class="mb-0">
                                    {{ accounts[0].account_type }}
                                </p>
                            </td>
                            <td>
                                <p class="mb-0">
                                    {{ accounts[1].account_type }}
                                </p>
                            </td>
                            <td>
                                <p class="mb-0">
                                    {{ accounts[2].account_type }}
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td>Account Detail:</td>
                            <td>
                                <p class="mb-0">
                                    {{ accounts[0].account_detail }}
                                </p>
                            </td>
                            <td>
                                <p class="mb-0">
                                    {{ accounts[1].account_detail }}
                                </p>
                            </td>
                            <td>
                                <p class="mb-0">
                                    {{ accounts[2].account_detail }}
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td>Bureau Code:</td>
                            <td>
                                <p class="mb-0">
                                    {{ accounts[0].bureau_code }}
                                </p>
                            </td>
                            <td>
                                <p class="mb-0">
                                    {{ accounts[1].bureau_code }}
                                </p>
                            </td>
                            <td>
                                <p class="mb-0">
                                    {{ accounts[2].bureau_code }}
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td>Monthly Payment:</td>
                            <td>
                                <p class="mb-0">
                                    {{ accounts[0].monthly_payment }}
                                </p>
                            </td>
                            <td>
                                <p class="mb-0">
                                    {{ accounts[1].monthly_payment }}
                                </p>
                            </td>
                            <td>
                                <p class="mb-0">
                                    {{ accounts[2].monthly_payment }}
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td>Payment Status:</td>
                            <td>
                                <p class="mb-0">
                                    {{ accounts[0].payment_status }}
                                </p>
                            </td>
                            <td>
                                <p class="mb-0">
                                    {{ accounts[1].payment_status }}
                                </p>
                            </td>
                            <td>
                                <p class="mb-0">
                                    {{ accounts[2].payment_status }}
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td>Past Due:</td>
                            <td>
                                <p class="mb-0">
                                    {{ accounts[0].past_due }}
                                </p>
                            </td>
                            <td>
                                <p class="mb-0">
                                    {{ accounts[1].past_due }}
                                </p>
                            </td>
                            <td>
                                <p class="mb-0">
                                    {{ accounts[2].past_due }}
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td>Date Opened:</td>
                            <td>
                                <p class="mb-0">
                                    {{ reportStore.formatDate(accounts[0].date_opened) }}
                                </p>
                            </td>
                            <td>
                                <p class="mb-0">
                                    {{ reportStore.formatDate(accounts[1].date_opened) }}
                                </p>
                            </td>
                            <td>
                                <p class="mb-0">
                                    {{ reportStore.formatDate(accounts[2].date_opened) }}
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td>BALANCE:</td>
                            <td>
                                <p class="mb-0">
                                    {{ reportStore.formatDate(accounts[0].balance) }}
                                </p>
                            </td>
                            <td>
                                <p class="mb-0">
                                    {{ reportStore.formatDate(accounts[1].balance) }}
                                </p>
                            </td>
                            <td>
                                <p class="mb-0">
                                    {{ reportStore.formatDate(accounts[2].balance) }}
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td>NUMBER OF MONTHS:</td>
                            <td>
                                <p class="mb-0">
                                    {{ reportStore.formatDate(accounts[0].number_of_months) }}
                                </p>
                            </td>
                            <td>
                                <p class="mb-0">
                                    {{ reportStore.formatDate(accounts[1].number_of_months) }}
                                </p>
                            </td>
                            <td>
                                <p class="mb-0">
                                    {{ reportStore.formatDate(accounts[2].number_of_months) }}
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td>Date Last Active:</td>
                            <td>
                                <p class="mb-0">
                                    {{ reportStore.formatDate(accounts[0].date_last_active) }}
                                </p>
                            </td>
                            <td>
                                <p class="mb-0">
                                    {{ reportStore.formatDate(accounts[1].date_last_active) }}
                                </p>
                            </td>
                            <td>
                                <p class="mb-0">
                                    {{ reportStore.formatDate(accounts[2].date_last_active) }}
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td>Date Last Payment:</td>
                            <td>
                                <p class="mb-0">
                                    {{ reportStore.formatDate(accounts[0].date_last_payment) }}
                                </p>
                            </td>
                            <td>
                                <p class="mb-0">
                                    {{ reportStore.formatDate(accounts[1].date_last_payment) }}
                                </p>
                            </td>
                            <td>
                                <p class="mb-0">
                                    {{ reportStore.formatDate(accounts[2].date_last_payment) }}
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td>High Credit:</td>
                            <td>
                                <p class="mb-0">
                                    {{ accounts[0].high_credit }}
                                </p>
                            </td>
                            <td>
                                <p class="mb-0">
                                    {{ accounts[1].high_credit }}
                                </p>
                            </td>
                            <td>
                                <p class="mb-0">
                                    {{ accounts[2].high_credit }}
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td>CREDIT LIMIT:</td>
                            <td>
                                <p class="mb-0">
                                    {{ accounts[0].credit_limit }}
                                </p>
                            </td>
                            <td>
                                <p class="mb-0">
                                    {{ accounts[1].credit_limit }}
                                </p>
                            </td>
                            <td>
                                <p class="mb-0">
                                    {{ accounts[2].credit_limit }}
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td>Last Reported:</td>
                            <td>
                                <p class="mb-0">
                                    {{ reportStore.formatDate(accounts[0].last_reported) }}
                                </p>
                            </td>
                            <td>
                                <p class="mb-0">
                                    {{ reportStore.formatDate(accounts[1].last_reported) }}
                                </p>
                            </td>
                            <td>
                                <p class="mb-0">
                                    {{ reportStore.formatDate(accounts[2].last_reported) }}
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td>Month Term:</td>
                            <td>
                                <p class="mb-0">
                                    {{ accounts[0].number_of_months }}
                                </p>
                            </td>
                            <td>
                                <p class="mb-0">
                                    {{ accounts[1].number_of_months }}
                                </p>
                            </td>
                            <td>
                                <p class="mb-0">
                                    {{ accounts[2].number_of_months }}
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td>Comments:</td>
                            <td>
                                <p class="mb-0">
                                    {{ accounts[0].comments }}
                                </p>
                            </td>
                            <td>
                                <p class="mb-0">
                                    {{ accounts[1].comments }}
                                </p>
                            </td>
                            <td>
                                <p class="mb-0">
                                    {{ accounts[2].comments }}
                                </p>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </template>
        </p>
        <p class="letter-content">
            Please provide me with a copy of my updated or corrected <strong>consumer file</strong> showing these items are removed.
            I demand the following listed accounts be legally verified by showing me the sources of verification or removed immediately.
        </p>
        <p class="letter-content">
            I assume that your company has verified the accuracy of these disputed items <strong>before</strong> you chose to published them on my credit report. <br/> Please provide me with copies of the documents that you have in your files as of this date that you used to verify the accuracy of the disputed accounts.
        </p>
        <p class="letter-content">
            Under the Fair Credit Reporting Act, <strong>in section § 609. Disclosures to consumers [15 U.S.C. § 1681g] </strong> I have the right to demand that you disclose to me all of the
            documents that you have recorded and retained in your file at the time of this request concerning the accounts listed above that you are reporting in my consumer file.
        </p>
        <p class="letter-content">
            It is my belief that the source documents used by the information provider are unreliable and that they have matched the disputed accounts to my credit file in error.
            Please verify that the social security number and signature <strong>on the credit application used to open these disputed accounts reported on my credit report are truly mine.</strong>
            You can do this by sending me a signed copy of the credit application that was used to open the disputed accounts.
            Please verify that all of the information given to you by the provider and then published on my report concerning these disputed accounts is accurate by sending me the documents you used to verify the accuracy of these items.
        </p>
        <p class="letter-content">
            <strong>***IMPORTANT*** Please don’t respond to my request by saying that these accounts have been verified by the information provider.</strong>
                Send me copies of the documents that you have retained in your files that your company used to verify the accuracy of these disputed accounts.
        </p>
        <p class="letter-content">
            <strong>I do not give your company permission to publish unverified information on my credit file.</strong>
            I am asking your company to legally verify the accuracy of these disputed items and not to just parrot what the information provider tells you.
            By publishing these unverified items on my credit report you are in violation of the FCRA and by distributing my credit report to 3rd parties you are damaging my reputation and credit worthiness.
        </p>
        <p class="letter-content">
            If you do not have any documentation in your files that verify the accuracy of these disputed accounts then <strong>please delete them immediately</strong> as required under <strong>Section 611(a)(5)(A)(i).</strong>
            You have not verified the accuracy of these accounts.  At best, you have only parroted what the information the provider told you.
            The law is clear, that a credit reporting agency that does not comply with the verification requirement of <strong>§1681i</strong> if it simply parrots the information provider’s electronic response.
        </p>
        <p class="letter-content">
            <strong>Under the FCRA 15 U.S.C. § 1681i, all unverified accounts MUST be promptly deleted.</strong>
            Therefore, if you are unable to provide me with a copy of the verifiable proof that you
            have on file for each of the accounts listed above within 30 days of receipt of this letter then you must remove these accounts from my credit report.
        </p>
        <p>
            <strong class="letter-content">* NOTE: Please also remove all non-account holding inquiries over 30 days old.</strong>
        </p>

        <p class="letter-content">
            In line with this, I was reviewing a copy of my Credit Karma credit report and discovered it contained some errors pertaining to the following “Personal Information.”
            I am requesting that you promptly INVESTIGATE, UPDATE and DELETE addresses that I never resided and may possibly be listed on my credit report due to fraud.
            Please see the attached copy of my Driver’s License and Social Security Number for your reference. For the record:
        </p>
        <p class="letter-content">
            My name is: {{ userStore.user.firstname }} {{ userStore.user.lastname }}
            <br />
            Please remove all other name variations <strong>IMMEDIATELY</strong>. They are not accurate.<br>
            Please remove any other phone numbers. They are not accurate. <br>
            Also, my current address is: {{ userStore.user.address }} {{ userStore.user.city }}, {{ userStore.user.state }} {{ userStore.user.zipcode }}
        </p>
        <p class="letter-content">
            All other addresses are not accurate. Please remove these addresses <strong>IMMEDIATELY:</strong>
        </p>
        <p class="letter-content">
            Please send me a notification that these items have been deleted, as well as updated. I hereby acknowledge that the above information is true and correct.
        </p>
        <p class="letter-content">
            P.S. Please be aware that dependent upon your response, I may be detailing any potential
            issues with your company via an online public press release, including documentation of
            any potential small claims action.
        </p>
        <p style="page-break-after: always;">
            Thank you for your time, <br> <br>
            {{ userStore.user.firstname }} {{ userStore.user.lastname }}
            <br />
            {{ userStore.user.address }}
            <br />
            {{ userStore.user.city }}, {{ userStore.user.state }} {{ userStore.user.zipcode }}
            <br />
            {{ userStore.user.ssn }}
        </p>
    </div>
    <h1 style="margin: 5rem 5rem;">Personal Information</h1>
    <div class="row">
        <p>
            <img v-if='userStore.user.ssn_image_url' v-bind:src='userStore.user.ssn_image_url' width='300' height='200' />
            <img v-if='userStore.user.identity_image_url' v-bind:src='userStore.user.identity_image_url' width='300' height='200' />
        </p>
        <p v-if='userStore.user.address_verify_image_url'>
            <img v-bind:src='userStore.user.address_verify_image_url' width='300' height='200' />
        </p>
    </div>
</template>
<script>
    import { ref, reactive, computed } from 'vue'
    import { useReportStore } from '../../stores/ReportStore.js'
    import { useUserStore } from '../../stores/UserStore.js'
    import moment from 'moment';
    export default {
        props: {
            creditBureau: {
                type: [Array, Object]
            }
        },
        setup(props) {
            return {
                date: ref(moment().format('LL')),
                reportStore: useReportStore(),
                userStore: useUserStore()
            };
        },
        computed: {
            selectedAccounts() {
                return _.filter(this.reportStore.reports[this.userStore.user.email].report.accounts, function(account) {
                    if (
                        account[0].checkbox && account[0].checkbox == "1"
                        ||
                        account[1].checkbox && account[1].checkbox == "1"
                        ||
                        account[2].checkbox && account[2].checkbox == "1"
                    ) {
                        return account;
                    }
                });
            }
        },
    };
</script>